import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '@/components/generic/Button';
import { PageContentContainer } from '@/components/layout/PageContentContainer';
import { ROUTES } from '@/router';

import { Props } from './types';

import styles from './PageNotFound.module.scss';

export const PageNotFound = ({ clearGlobalError }: Props) => {
  const history = useHistory();
  const navigateHome = useCallback(() => {
    history.push(ROUTES.Private.Dashboard.ActivityList);
    clearGlobalError();
  }, [clearGlobalError, history]);

  return (
    <PageContentContainer
      breadcrumbs={[
        { title: 'My Dashboard', handleOnClick: navigateHome },
        { title: 'Page not found', current: true },
      ]}
      className={styles.content}
    >
      <h1>Page not found</h1>

      <p>
        The page you are looking for might have been removed, had its name changed or is temporary
        unavailable
      </p>

      <Button color="red" onClick={navigateHome}>
        Go to My Dashboard
      </Button>
    </PageContentContainer>
  );
};
